<script lang="ts">
  import { i18n } from '../i18n/index.svelte';
  import { router } from '../stores/router.svelte';
  import PixelIcon from './PixelIcon.svelte';

  interface Props {
    title: string;
    /** Hidden on the menu, which has nowhere to go back to. */
    back?: boolean;
  }

  let { title, back = true }: Props = $props();

  const t = $derived(i18n.t);
</script>

<header class="view__header">
  {#if back}
    <button
      type="button"
      class="topbar__back"
      onclick={() => router.back()}
      aria-label={t.common.ariaBack}
    >
      <PixelIcon name="back" size={28} />
    </button>
  {:else}
    <span class="topbar__spacer" aria-hidden="true"></span>
  {/if}

  <h1 class="view__title">{title}</h1>

  <!-- Keeps the title optically centred without a second layout pass. -->
  <span class="topbar__spacer" aria-hidden="true"></span>
</header>
